import React, { useState, useEffect, useRef, Fragment } from "react";
import {
    NavLink,
  useNavigate,
  useParams
} from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
import { Rnd } from "react-rnd";
import gsap from "gsap";
import { ChromePicker } from 'react-color';
import SVG from 'react-inlinesvg';
import { apiCall } from "./narrativeUtils/fetch";
import Modal from './module.modal';
import ContextMenu from './module.contextMenu';
import Config from "../Config.json"
import Loader from "../static/svg/loader.svg";
import imagePlaceholder from '../static/img/image.png'

// Icons
import Icons from './module.icons';
import OpenLink from "../static/svg/openLink-w.svg";
import {ReactComponent as Close} from "../static/icons/close.svg" 
import {ReactComponent as Edit} from "../static/icons/edit.svg" 
import {ReactComponent as Add} from "../static/icons/library_add.svg" 
import {ReactComponent as Presentation} from "../static/modules/presentation.svg" 
import {ReactComponent as WebGL} from "../static/modules/3d.svg" 
import {ReactComponent as Doc} from "../static/modules/doc_library.svg" 
import {ReactComponent as GalleryImage} from "../static/modules/gallery_image.svg" 
import {ReactComponent as Timeline} from "../static/modules/timeline-icon-flat.svg" 
import {ReactComponent as GalleryVr} from "../static/modules/gallery_vr.svg" 
import {ReactComponent as GalleryVideo} from "../static/modules/gallery_video.svg" 
import {ReactComponent as Map} from "../static/modules/map.svg" 
import {ReactComponent as Stack} from "../static/modules/stack_typical.svg" 
import {ReactComponent as Image} from "../static/icons/image.svg"
import {ReactComponent as Video} from "../static/icons/video.svg"
import {ReactComponent as Svg} from "../static/icons/svg.svg"
import {ReactComponent as Linked} from "../static/icons/link.svg"
import {ReactComponent as ChevronDown} from "../static/icons/chevron_down.svg" 

const fontFamilies = ['CerebriSans', 'Arial', 'Verdana', 'Tahoma', 'Trebuchet', 'Times New Roman', 'Georgia', 'Georgia', 'Garamond', 'Courier New'];

const HomeVideo = React.memo(React.forwardRef((props,ref)=>{
  return (<video ref={ref} key={`home-vid-bg`} className={`fullscreen backgroundVideo constant`} muted loop autoPlay src={props.src} alt="" open={props.open}
   onLoadedMetadata={props.onLoadedMetadata} 
   id="home-bg-video" ></video>)

}))
const videoPath = Config.mediaURL + 'core/home/bg.mp4?d='+((new Date()).getTime())

function Narrative(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  const colorPicker = useRef();
  const [narrative, setNarrative] = useState(null);
  const [modules, setModules] = useState(null);
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [animOpen, setAnimOpen] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [reloadIframe, setReloadIframe] = useState(0);
  const [dropDown, setDropDown] = useState();
  const [tempColor, setTempColor] = useState();
  const [showModuleForm, setShowModuleForm] = useState(false);
  const [newModule, setNewModule] = useState();
  const [tempModuleTitle, setTempModuleTitle] = useState();
  const [narrativeUpdating, setNarrativeUpdating] = useState(false);
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [groups, setGroups] = useState([]);
  const [screenSaver, setScreenSaver] = useState(null);
  const [contextBtns, setContextBtns] = useState([
    {text: "Settings", action: () => setShowModuleForm('moduleSettings')},
    {text: "Delete", action: () => deleteModule()}
  ]);

  function animDropDown(open){
    if (open) {
      console.log(open, dropDown)
      // let parent = document.getElementById('settingsRow_' + dropDown).getBoundingClientRect().x;
      let parent = document.getElementById('settingsRow_' + dropDown).offsetLeft;
      let dropDownElem = document.getElementById("inputField_" + dropDown).offsetLeft;
      let offsetLeft = parent - dropDownElem;
      // console.log('offsetLeft', offsetLeft);
      gsap.to(dropDownElem, {y: offsetLeft, duration: 0});
      var tl = gsap.timeline();
      
      tl.to("#inputField_" + dropDown + " .dropDownChoices", {height: "auto", duration: 0});
      tl.to("#inputField_" + dropDown, {zIndex: 3, x: offsetLeft, height: 'auto', duration: 0}, '<');
      tl.to("#inputField_" + dropDown, {scale: 1, opacity: 1, duration: 0.1});
    } else {
      gsap.to(".dropDownChoices", {height: 0, duration: 0});
      gsap.to(".dropDownField", {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
    }
  }

  function handleDropDown(e, field) {
    if (field === dropDown) {
      setDropDown(null); 
    } else {
      setDropDown(field)
    }
  }


  function fileNameType(string, layerName, length) {
    let x0 = string.replace('img/', '');
    let x1 = x0.replace('svg/', '');
    let x2 = x1.replace('core/', '');
    let x = x2.replace('narrative/', '');
    var ext = string.split('.').pop();
    let x3;
    if (layerName) {
      x3 = layerName;
    } else {
      x3 = x.replace('.'+ext, '');
    }
  
    // console.log('fileNameType', ext, x2, string);
    let icon;
    switch (ext) {
      case "png":
        icon = <Image className="icon" />
        break;
      case "jpg":
        icon = <Image className="icon" />
        break;
      case "jpeg":
        icon = <Image className="icon" />
        break;
      case "webp":
        icon = <Image className="icon" />
        break;
      case "svg":
        icon = <Svg className="icon" />
        break;
      case "mp4":
        icon = <Video className="icon" />
        break;
      case "mov":
        icon = <Video className="icon" />
        break;
      case "MOV":
        icon = <Video className="icon" />
        break;
      default:
        break;
    }
    let limit = 24;
    if (length) {
      limit = length
    }
    if (x3.length > limit) {
      x3 = x3.substring(0,limit) + ' ...'
    }
    let result = [icon, x3];
    return result;
  }

  let moduleObjs = [];
  let acceptValues = "image/png, image/jpeg, image/webp, video/mp4, video/quicktime, image/svg+xml";

  function animColorPicker(open, id){
    setTempColor(null)
    if (animOpen) {
      gsap.to('.colorPicker', {height: 0, duration: 0});
      gsap.to('.colorPicker', {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
    }
    if (open !== id) {
      
      var tl = gsap.timeline();
      tl.to("#" + id, {height: "auto", duration: 0});
      tl.to("#" + id, {zIndex: 3, height: "auto", duration: 0}, "<");
      tl.to("#" + id, {scale: 1, zIndex: 3, opacity: 1, duration: 0.1});
      setAnimOpen(id);
    } else {
      gsap.to("#" + id, {height: 0, duration: 0});
      gsap.to("#" + id, {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
      setAnimOpen(null);
    }
  }

  
  function getModules(paths) {
    let moduleObjs = [];
    for(var i = 0; i < paths.length; i++) {            
      try {
        axios({
            method: "get",
            url: paths[i],
            headers: {
              Authorization: 'Token ' + Cookies.get('_expo_tokenid')
            },
        }).then((response) => {
            const objJSON = response.data;
            moduleObjs.push(objJSON);

            if (paths.length === moduleObjs.length) {
              let exclude = ['webgl', 'stack', 'document', 'screensaver'];
             
              let objs = moduleObjs.filter(a => !exclude.includes(a.typeName))
              
  
              let docs = moduleObjs.find(b => b.typeName === 'document')
              let screensaver = moduleObjs.find(b => b.typeName === 'screensaver')
              let final;
              if (screensaver) {
                screensaver.ordering = 10
                let final0 = [docs].concat([screensaver])
                final = objs.concat(final0);
                setScreenSaver(screensaver);
              } else {
                final = objs.concat(docs);
              }
              
              
              setModules(final);
              console.log('setModules', final)
            }
           
        });
      } catch (error) {
          console.error(error);
      }  
    }
   
    return paths.length === moduleObjs.length;
  }

  function fetchJSON(hasNewObjId) {
 
    try {
        axios({
            method: "get",
            url: Config.baseURL + "/api/cms/narrative-landing/" + id,
            headers: {
              Authorization: 'Token ' + Cookies.get('_expo_tokenid')
            },
        }).then((response) => {
            const assetJSON = response.data;
            setNarrative(assetJSON);
            console.log('narrative-landing', assetJSON)
      
           
            
        });
    } catch (error) {
        console.error(error);
    }

    try {
      axios({
          method: "get",
          url: Config.baseURL + "/api/cms/narrative-group/",
          headers: {
            Authorization: 'Token ' + Cookies.get('_expo_tokenid')
          },
      }).then((response) => {
          const assetJSON = response.data;
          setGroups(assetJSON);
          console.log('narrative-groups', assetJSON)
    
         
          
      });
  } catch (error) {
      console.error(error);
  }



    
}

  function handleBackBtn(step){
    if (step === 'step1') {
      setShowError(true);
    } 
    if (step === 'cancel') {
      setShowError(false);
    } 
  
    if (step === 'force') {
      navigate('/narratives/' + narrative.id)
    } 
  
  
  }

  useEffect(() => {
    if (narrative && narrative.modules) {
      function modulesLoaded(){
        getModules(narrative.modules);
        
        // setReloadIframe(reloadIframe + 1)
      };

      modulesLoaded();
    }
  }, [narrative])

  useEffect(() => {
    if (dropDown) {
      animDropDown(true)
    } else {
      animDropDown(false)
    }
  }, [dropDown])

  useEffect(() => {
    if (modules && modules.length > 0) {
      setShowLoader(false);
    }
  }, [modules])

  useEffect(() => {
    props.setTools("search")
    fetchJSON(false);

    localStorage.removeItem("versionHistory");
  }, []);

  useEffect(() => {
    if (!showModuleForm) {
      setShowContextMenu(false);
    } else {
      // let elems1 = document.querySelector('.moduleSettings').querySelector('.stop1')
      // console.log('e1', elems1)
      // for (var i = 0; i < elems1.length; i++) {
      //   if (narrative.theme_css && narrative.theme_css['module-stop-0']) {
      //     elems1[i].setAttribute('stop-color', narrative.theme_css['module-stop-0'])
      //     console.log('element',  elems1[i])
      //   }
      // }
      // gsap.to(".fieldRow .stop1", {'stopColor': narrative.theme_css['module-stop-0']})
      // let elems2 = document.querySelector('.moduleSettings').querySelector('.stop2')
      // for (var i = 0; i < elems1.length; i++) {
      //   if (narrative.theme_css && narrative.theme_css['module-stop-0']) {
      //     elems2[i].setAttribute('stop-color', narrative.theme_css['module-stop-0'])
      //     console.log('element',  elems2[i])
      //   }
      // }
    
      // let elems2 = document.querySelector('.moduleSettings').getElementsByClassName('stop2')
      // elems2.forEach(element => {
      //   if (narrative.theme_css && narrative.theme_css['module-stop-1']) {
      //     element.setAttribute('stop-color', narrative.theme_css['module-stop-1'])
      //   }
      // });
    }
  }, [showModuleForm])

  useEffect(() => {
    if (showContextMenu) {
      
      
    }
    console.log('showContextMenu', showContextMenu)
  }, [showContextMenu])

  function handleNarrativeSave(field, value) {
    setShowLoader(true)
    const api_url = Config.baseURL + '/api/cms/narrative-settings/' + narrative.id + "/";
    var dataJSON = {};
    if (field !== 'title') {
      dataJSON['title'] = narrative.title
    }
    dataJSON[field] = value;

    console.log('handleNarrativeSave', dataJSON)
    
    axios({
        method: 'POST',
        url: api_url,
        data: dataJSON,
        headers: {
          Authorization: 'Token ' + Cookies.get('_expo_tokenid')
        },
    })
    .then(response => {
        console.log('handleNarrativeSave', response);
        fetchJSON(false);
        setTempColor(null);
    })
    .catch(error => {
        console.log('error', error.response);
    });
  }

  function handleNarrativeMedia(fileName){
    var fileList = document.getElementById(fileName).files;
    var arrayLength = fileList.length;
    for (var i = 0; i < arrayLength; i++) {
      var formData = new FormData();
      formData.append(fileName, fileList[i], fileList[i].name) 
      const api_url = Config.baseURL + '/api/cms/narrative-settings/' + narrative.id + "/";
      formData.append('title', narrative.title)
      formData.append('active', narrative.active)
      axios({
          method: 'POST',
          url: api_url,
          data: formData,
          headers: {
            Authorization: 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          console.log('handleNarrativeMedia', response);
          fetchJSON(false);
      })
      .catch(error => {
          console.log('error', error.response);
      });
      

    } 
  }

  function handleNarrativeBackground(fileName, objId){
    var fileList = document.getElementById(fileName).files;
    var arrayLength = fileList.length;
    for (var i = 0; i < arrayLength; i++) {
      var formData = new FormData();
      formData.append('image', fileList[i], fileList[i].name) 
      const api_url = Config.baseURL + '/api/cms/narrative-background/' + objId + "/";
      axios({
          method: 'POST',
          url: api_url,
          data: formData,
          headers: {
            Authorization: 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          console.log('handleNarrativeBackground', response);
          fetchJSON(false);
      })
      .catch(error => {
          console.log('error', error.response);
      });
      

    } 
  }


  function handleThemeCss(obj, field, value){
    let newCss;
    if (narrative[obj]) {
      newCss = narrative[obj];
    } else {
      newCss = {};
    }
    // console.log('handleThemeCss', obj, field, value, newCss)
    if (value) {
      newCss[field] = value;
    } else {
      delete newCss[field]; 
    }
    setTimeout(() => {
      handleNarrativeSave(obj, newCss);
      setDropDown(null);
    }, 300);
  }

  function copyLink(e, copyText) {
    let t = e.target;
    let tl = gsap.timeline({
      defaults: {
        ease: "power1",
        duration: 0.3
      }
    });
    tl.to(t, {color: "#007AFF"})
    tl.to('.animFill path', {fill: "#007AFF"}, "<")
    tl.to(t, {color: "#ffffff"})
    tl.to('.animFill path', {fill: "#FFFFFF"}, "<")
    navigator.clipboard.writeText(copyText);
    console.log('copyLink', copyText)
  }

  function handleStatus(status) {
    handleNarrativeSave('status', status);
   setDropDown(null);
  }

  function handleTransition(value) {
    handleNarrativeSave('transition', value);
   setDropDown(null);
  }

  function handleNewTitle(e, value) {
    if (e.key === "Enter") {
      handleNarrativeSave('title', e.target.value);
    }
  }

  function handleNewSubTitle(e, value) {
    if (e.key === "Enter") {
      handleNarrativeSave('subheading', e.target.value);
    }
  }


  function handleAddNewModule(slug) {
    setShowLoader(true)
    const api_url = Config.baseURL + '/api/cms/' + slug + '-add/' + id + "/";
    var dataJSON = {};
    dataJSON['status'] = "new"
    dataJSON['title'] = tempModuleTitle
    axios({
        method: 'POST',
        url: api_url,
        data: dataJSON,
        headers: {
          Authorization: 'Token ' + Cookies.get('_expo_tokenid')
        }
    })
    .then(response => {
        console.log('add module response', response.data['id'])
        fetchJSON(response.data['id']);
        setTempModuleTitle(null);
        setShowModuleForm(false);
        setTempColor(null);
    })
    .catch(error => {
        console.log('error', error.response);
    });
  } 

  function saveModuleForm(){
    setShowContextMenu(false);
  }

  function onModuleFormSave(form) {
    console.log('onModuleFormSave', form)
    let moduleType = form[0]
    let objId = form[1]
    let backgrounds = []

    if (form[2]) {
      backgrounds = form[2]
    }

    setShowLoader(true)
    let api_url;
    let dataJSON = {};
    let id;
    let icon_name;
    let title;

    if (moduleType !== 'screensaver') {
      title = document.getElementById('moduleTitle').value;
      dataJSON['module_settings'] = true
      dataJSON['title'] = title
      dataJSON['icon_name'] = ""
    }
    
    

    switch (moduleType) {
      case 'gallery':
        id = objId.replace('gallery-','')
        api_url = Config.baseURL + '/api/cms/gallery/' + id + "/";
        icon_name = document.getElementById('moduleIconValue').value;
        let ordering = document.getElementById('moduleOrdering').value;
        if (icon_name) {
          dataJSON['icon_name'] = icon_name
        } else {
          dataJSON['icon_name'] = "Gallery Images"
        }

        dataJSON['ordering'] = ordering
        break;
      case 'document':
        id = objId.replace('documents-','')
        api_url = Config.baseURL + '/api/cms/documents/' + id + "/";
        icon_name = document.getElementById('moduleIconValue').value;
        dataJSON['icon_name'] = "Documents"
        break;
      case 'timeline':
        id = objId.replace('timeline-','')
        api_url = Config.baseURL + '/api/cms/timeline/' + id + "/";
        break;
      case 'mapbox':
        api_url = Config.baseURL + '/api/cms/mapbox/' + objId + "/";
        break;
      case 'stack':
        api_url = Config.baseURL + '/api/cms/stack/' + objId + "/";
        break;
      case 'screensaver':
        dataJSON = new FormData();
       
        var fileList = document.getElementById('screenSaverFile').files;
        var arrayLength = fileList.length;
        for (let j = 0; j < arrayLength; j++) {
          dataJSON.append('file', fileList[j], fileList[j].name) 
        }
          
        if (screenSaver && screenSaver.files && screenSaver.files.length > 0) {
          id = screenSaver.id.replace('screensaver-','')
          api_url = Config.baseURL + '/api/cms/screensaver/' + objId + '/';
        } else {
          if (form[3]) {
            id = form[3].replace('screensaver-','')
          }
          api_url = Config.baseURL + '/api/cms/screensaver/new/';
           
        }

        dataJSON.append('screensaver', id)
          
        

        break;
      default:
        break;
    }


    console.log('onModuleFormSave', form, dataJSON)
      
      axios({
          method: 'POST',
          url: api_url,
          data: dataJSON,
          headers: {
            Authorization: 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          console.log('onModuleFormSave', response);
       

           if (backgrounds.length > 0) {
              backgrounds.forEach((o, i) => {
                console.log('backgrounds', o, i);
              let id = document.getElementById('moduleBackgroundId-' + i).value;       
              var fileList = document.getElementById('moduleBackground-' + i).files;
              var arrayLength = fileList.length;
             
            
              for (let j = 0; j < arrayLength; j++) {
             
                var formData = new FormData();
                formData.append('image', fileList[j], fileList[j].name) 
                const api_url = Config.baseURL + '/api/cms/' + moduleType + '-background/' + id + "/";
                axios({
                    method: 'POST',
                    url: api_url,
                    data: formData,
                    headers: {
                      Authorization: 'Token ' + Cookies.get('_expo_tokenid'),
                      'Content-Disposition': 'attachment; filename=' + fileList[j].name
                    },
                })
                .then(response => {
                    console.log('backgrounds', response);
                    // fetchJSON(false);
                })
                .catch(error => {
                    console.log('error', error.response, error);
                });
                
          
              } 

            })
          
          }
          
          let newBackgrounds = document.getElementById('moduleBackground-new');
          if (newBackgrounds) {
              var fileList = document.getElementById('moduleBackground-new').files;
              var arrayLength = fileList.length;
              for (let j = 0; j < arrayLength; j++) {
                console.log('file', fileList[j], fileList[j].name)
                var formData = new FormData();
                
                if (showContextMenu.module === 'document') {
                  formData.append('module_id', showContextMenu.obj.id.replace('documents-', ''))
                } else {
                  formData.append('module_id', showContextMenu.obj.id.replace(showContextMenu.module + '-', ''))
                }
                formData.append('module_type', showContextMenu.module)
                formData.append('image', fileList[j], fileList[j].name) 
                const api_url = Config.baseURL + '/api/cms/module-background-add/';

                // console.log('new background', showContextMenu.module, showContextMenu.obj.id.replace(showContextMenu.module + '-', ''), fileList)

                for (var pair of formData.entries()) {
                  console.log('FORM DATA', pair[0]+ ', ' + pair[1]); 
                }

                axios({
                    method: 'POST',
                    url: api_url,
                    data: formData,
                    headers: {
                      'Content-Disposition': 'attachment; filename=' + fileList[j].name,
                      Authorization: 'Token ' + Cookies.get('_expo_tokenid')
                    },
                })
                .then(response => {
                    console.log('backgrounds new', response);
                    // fetchJSON(false);
                    fetchJSON(false);
                    setTempColor(null);
                    setShowContextMenu(false);
                    setShowModuleForm(false);
                })
                .catch(error => {
                    console.log('error', error.response);
                });

    
          
              } 

          setShowModuleForm(false);
          } else {
            fetchJSON(false);
            setTempColor(null);
            setShowContextMenu(false);
            setShowModuleForm(false);
          }

          
          
      })
      .catch(error => {
          console.log('error', error.response, error);
      });

      

  }

  
  function onFormModuleClick(e, name) {
    document.getElementById('moduleIconValue').value = name
    let icons = document.querySelectorAll('.formIcon');
    icons.forEach(a => a.classList.remove('on'));
    
    e.target.classList.add('on');

  }

  function deleteModule(moduleTypeName, objId) {
    console.log('delete module', moduleTypeName, objId)
    const api_url = Config.baseURL + '/api/cms/module-delete/';
    let idFull = objId
    let id = idFull.replace(moduleTypeName + "-", "")
    let formData = {
      'id': id,
      'module': moduleTypeName
    }
    axios({
      method: 'POST',
      url: api_url,
      data: formData,
      headers: {
        Authorization: 'Token ' + Cookies.get('_expo_tokenid')
      },
  })
  .then(response => {
     
      fetchJSON(false);
  })
  .catch(error => {
      console.log('error', error.response);
  });
  
  }
  
  function updateFileName(e, id) {
    let elem = document.getElementById(id)
    let files = e.target.files;
    let fileName = files[0].name;
    elem.innerHTML = fileName
    
    
  }

  function handleAddCategory(name) {
    setShowLoader(true);
    const api_url = Config.baseURL + "/api/cms/narrative-group/";
    var dataJSON = {
      'name': name,
      'org': props.user && props.user.org && props.user.org.id
    };
    axios({
      method: "POST",
      url: api_url,
      data: dataJSON,
      headers: {
        Authorization: "Token " + Cookies.get("_udxdid"),
      },
    })
      .then((response) => {

        handleNarrativeSave('group', response.data['id'])
       
        // fetchJSON();
        setShowCategoryForm(false);
      })
      .catch((error) => {
        console.log("error", error.response);
      });
  }

  

    function onModuleContext(e, moduleTypeName, id) {
      console.log('modules', modules, moduleTypeName)
      e.preventDefault();

      if (moduleTypeName === 'screensaver'){
        setContextBtns([{text: "Settings", action: () => setShowModuleForm('screensaver')},{text: "Delete", action: () => deleteModule(moduleTypeName, id)}])
      } else {
        setContextBtns([
          {text: "Settings", action: () => setShowModuleForm('moduleSettings')},
          {text: "Delete", action: () => deleteModule(moduleTypeName, id)}
        ])
      }
      console.log('contextBtns', contextBtns)
      let obj = modules.find(a => a.id === id)
      console.log('onModuleContext', moduleTypeName, id, obj)
      setShowContextMenu({module: moduleTypeName, obj: obj, pageX: e.pageX, pageY: e.pageY})
      console.log('showContextMenu', {module: moduleTypeName, obj: obj, pageX: e.pageX, pageY: e.pageY})
    }

  const choices = (
    <div className="buttons">
      <div style={{display: "none"}} className={"btn1" + ((modules && modules.findIndex(a => a.typeName === 'mapbox') > -1)?" off":"")}  onClick={() => setShowModuleForm('mapbox')}>
        <div className="iconField"><Map className="iconLg" /> Map</div>
      </div>
      <div className={"btn1"} onClick={() => setShowModuleForm('gallery')}>
        <div className="iconField"><GalleryImage className="iconLg" /> Gallery</div>
      </div>
     {((props.user && props.user.org && props.user.org.id === 1)||(props.user && props.user.org && props.user.org.id === 8)) && <div className={"btn1"} onClick={() => setShowModuleForm('timeline')}>
        <div className="iconField"><Timeline className="iconLg" /> Timeline</div>
      </div>}
    </div>
  )

  const titleRow = (<div className="settingsRow"><input type="text" autoComplete="off" required onChange={(e) => {setTempModuleTitle(e.target.value)}} placeholder="Add a Title" /></div>)


  const moduleSettings = (<span className="moduleSettings"> 
   
    <div className="settingsRow">
      <span className="fieldRow">
        <span className="canvasLabel">Title</span>
        <input type="text" id="moduleTitle" defaultValue={showContextMenu && showContextMenu.obj.title}/>
      </span>
    </div>

    <div className="settingsRow">

      {showContextMenu && showContextMenu.module !== 'presentation' && <span className="settingsRow">
      <span className="fieldRow">
      {(showContextMenu.module === 'gallery' || showContextMenu.module === 'document' || showContextMenu.module === 'mapbox' || showContextMenu.module === 'stack') &&  <span className="canvasLabel">Icon</span>}
        {showContextMenu.module === 'gallery' && <span className="flex fieldRow">
          <Icons.GalleryImages className={"formIcon ui" + (showContextMenu.obj.icon_name === "Gallery Images"?" on":"")} onClick={(e) => onFormModuleClick(e, 'Gallery Images')}  />
          <Icons.GalleryVideos className={"formIcon ui" + (showContextMenu.obj.icon_name === "Gallery Videos"?" on":"")} onClick={(e) => onFormModuleClick(e, 'Gallery Videos')} />
          <Icons.GalleryVrs className={"formIcon ui" + (showContextMenu.obj.icon_name === "Gallery VRs"?" on":"")} onClick={(e) => onFormModuleClick(e, 'Gallery VRs')} />
        </span>}
        {showContextMenu.module === 'document' && <span className="flex fieldRow">
          <Icons.Documents className="formIcon ui on" />
        </span>}
        {showContextMenu.module === 'mapbox' && <span className="flex fieldRow">
          <Icons.MapBox className="formIcon ui on" />
        </span>}
        {showContextMenu.module === 'stack' && <span className="flex fieldRow">
          <Icons.StackBuilding className={"formIcon ui" + (showContextMenu.obj.icon_name === "Stack Building"?" on":"")} onClick={(e) => onFormModuleClick(e, 'Stack Building')} />
          <Icons.StackPlan className={"formIcon ui" + (showContextMenu.obj.icon_name === "Stack Plan"?" on":"")} onClick={(e) => onFormModuleClick(e, 'Stack Plan')} />
        </span>}
      </span>
      </span>}
      <input type="hidden" id="moduleIconValue" defaultValue={showContextMenu.obj &&showContextMenu.obj.icon_name && showContextMenu.obj.icon_name} />
    </div>

    {showContextMenu && showContextMenu.obj.backgrounds && <span className="backgroundsRow fieldRow">
      <div className="canvasLabel ui">Backgrounds</div>
      {showContextMenu.obj.backgrounds.map((b, i) => (
        <div className="selectFileRow fieldRow" key={'moduleBkg_' + i}>
        <span className="canvasLabel">{b.name}</span> 
        <div className="iconField ui" onClick={() => document.getElementById('moduleBackground-' + i).click()}> 
          {b.image ? fileNameType(b.image_name, null, 100).map((obj2, j) => (
          <span key={"fileName_" + j}>{obj2}</span>)) : <span className="canvasLabel">Add File</span>}</div>
         
          <input type="file" style={{"display": "none"}} id={'moduleBackground-' + i} accept={acceptValues} multiple={false} />
         
          <input type="hidden" id={'moduleBackgroundId-' + i} value={b.id} />
        </div>))}

        {(showContextMenu.obj.backgrounds.length === 0) &&
          <div className="selectFileRow fieldRow">
          
          <div className="iconField ui" onClick={() => document.getElementById('moduleBackground-new').click()}> 
            <span className="canvasLabel" id="fileNameNew">Add File</span></div>
           
            <input type="file" style={{"display": "none"}} id={'moduleBackground-new'} accept={acceptValues} onChange={(e) => updateFileName(e, 'fileNameNew')} multiple={false} />
          
          </div>}

      </span>
    }




    {showContextMenu.module === 'gallery' &&<div className="settingsRow">
    <span className="fieldRow">
      <span className="canvasLabel">Order</span>
      <input type="number" id="moduleOrdering" defaultValue={showContextMenu && showContextMenu.obj.ordering} />
    </span>
  </div>}

  
  </span>)


  function updateScreenSaverFile(e) {
    let file = e.target.files
    if (file) {
      file = e.target.files[0].name
      document.getElementById('screenSaveFileName').innerHTML = file
    }
    
  }
    

  const screenSaverSettings = (<span className="moduleSettings"> 


  <span className="backgroundsRow fieldRow">


      <div className="selectFileRow fieldRow">
      <span className="canvasLabel">Screensaver Video</span> 


  
      <div className="iconField ui" id="screenSaveFileName" onClick={() => document.getElementById('screenSaverFile').click()}> 
        {(screenSaver && screenSaver.files && screenSaver.files.length > 0) ? fileNameType(screenSaver.files[0].file, null, 100).map((obj2, j) => (
        <span key={"fileName_" + j}>{obj2}</span>)) : <span className="canvasLabel">Add File</span>}</div>
       
        <input type="file" style={{"display": "none"}} id={'screenSaverFile'} accept={"video/mp4"} onChange={(e) => updateScreenSaverFile(e)} multiple={false} />
     


      </div>
    </span>
  




</span>)


    return (
        
        <section className="main">

        {showCategoryForm && (
          <div className="modalContainer">
            <div className="modal">
              <span>
                <h3>{"New Category"}</h3>
  
                <div className="settingsRow">
                  <input
                    type="text"
                    autoComplete="off"
                    id="newCategoryName"
                    autoFocus
                    placeholder="Add Category Name"
                  />
                </div>
              </span>{" "}
              <div className="fullRow errorRow">
                <span
                  onClick={() => {
                    setShowCategoryForm(false);
                  }}
                >
                  Cancel
                </span>{" "}
                <span
                  onClick={() =>
                   { 
                     handleAddCategory(
                        document.getElementById("newCategoryName").value
                      )
                  }
                  }
                >
                  Continue
                </span>
              </div>
            </div>
          </div>
        )}
      

        {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}
        {(showError)&&(<div id="errorPopup"><div className="modal"><span><h3>Unsaved Changes</h3><p>Are you sure you want to go back?</p></span> <div className="fullRow errorRow"><span onClick={() => handleBackBtn('cancel')}>Cancel</span> <span onClick={() => handleBackBtn('force')}>Continue</span></div></div></div>)}
        
        {(showModuleForm === true) && <Modal heading={"Modules"} text={"Add a Module"} choices={choices} onBtn1Click={setShowModuleForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}

        {(showModuleForm === 'gallery') && <Modal heading={"New Gallery Page"} choices={titleRow} onBtn1Click={setShowModuleForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAddNewModule} onBtn2={'gallery'} btn2Text={"Create"} />}

        {(showModuleForm === 'timeline') && <Modal heading={"New Timeline Page"} choices={titleRow} onBtn1Click={setShowModuleForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAddNewModule} onBtn2={'timeline'} btn2Text={"Create"} />}

        {(showModuleForm === 'mapbox') && <Modal heading={"New Map Page"} choices={titleRow} onBtn1Click={setShowModuleForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={handleAddNewModule} onBtn2={'mapbox'} btn2Text={"Create"} />}

        {(showModuleForm === 'moduleSettings' && showContextMenu) && <Modal heading={"Settings"} choices={moduleSettings} onBtn1Click={setShowModuleForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={onModuleFormSave} onBtn2={[showContextMenu.module, showContextMenu.obj.id, showContextMenu.obj.backgrounds]} btn2Text={"Save"} />}
      {console.log('showModuleForm', showModuleForm)}
        {(showModuleForm === 'screensaver') && <Modal heading={"Settings"} choices={screenSaverSettings} onBtn1Click={setShowModuleForm} onBtn1={false} btn1Text={"Cancel"} onBtn2Click={onModuleFormSave} onBtn2={['screensaver', screenSaver && screenSaver.files && screenSaver.files.length > 0 && screenSaver.files[0].id, null, screenSaver &&  screenSaver.id]} btn2Text={"Save"} />}
        
        {(showShare)&&(<div className="modalContainer shareModal"><div className="modal">
          <span className="iconField ui closeBtn" onClick={() => setShowShare(false)}><Close className="iconLg fillWhite" /></span>
          <span className="textContainer">
          <h3>Share</h3>
          <span className="textInner">
            <p>Click the link below to copy the share link.</p><p>Anyone with this link can view the presentation, without a username and password.</p>
            <p><span className="copyLink ui iconField" onClick={(e) => copyLink(e, Config.previewURL + "/narrative/" + narrative.id + "?u=" + props.user.link_token)}><Linked className="icon animFill" /> Copy Link</span></p>
    
          </span>
          </span>
          </div></div>)}

        <div id="narrativeOverviewTools">


          <div className="heading">
          <h1>{narrative && narrative.title}</h1>
        </div>

          {narrative && <a href={ Config.previewURL + "/narrative/" + narrative.id + "?u=" + props.user.link_token + "&nav=closed"} className="previewBtn" target="_blank" rel="noreferrer" title="preview">
          <img src={OpenLink} className="icon" alt="" /></a>}

          {narrative && console.log('share link', Config.previewURL + "/narrative/" + narrative.id + "?u=" + props.user.link_token + "&nav=closed")}


        </div>

        {narrative && modules && !showLoader && <div className="col appGrid previewGrid">
          
            <nav className="moduleNav">

            
            <HomeVideo key={`home-video`} src={videoPath} alt="" id="home-bg-video" />
                  <ContextMenu 
                    contextBtns={contextBtns}
                    onContext={showContextMenu}
                    setShowContextMenu={setShowContextMenu}
                  />

                  <div className="moduleGrid">

                  

                   <NavLink 
                    to={'/narratives/' + narrative.id + "/pages"}
                    className={"moduleIcon"}
                    // onContextMenu={(e) => onModuleContext(e, 'narrative', narrative.id)}
                    >
                      <Icons.Presentation className="iconLg" />
                      {narrative && narrative.title }
                    </NavLink>
            


                  {(modules && modules
                    .filter(a => a.typeName !== "screensaver")
                    .sort((a, b) => (b.pk - a.pk) )
                    .sort((a, b) => (b.ordering - a.ordering))
                    .map((obj, i) =>
                    <NavLink 
                      key={"module_" + i}
                      to={"/modules/" + obj.typeName + "/" + ((obj.typeName === 'document')?obj.id.replace("documents-",""):obj.id.replace(obj.typeName + "-",""))}
                      className={"moduleIcon"}
                      onContextMenu={(e) => onModuleContext(e, obj.typeName, obj.id)}
                    >

                      
                      {obj.icon && <SVG 
                        src={Config.mediaURL + obj.icon} 
                        cacheRequests={true}
                        className="iconLg" 
                        loader={<span className="iconLg svgLoader"></span>}
                        onLoad={(src, isCached) => console.log(src, isCached)}
                        fetchOptions={{ credentials: 'omit' }}
                        // preProcessor={(code) => code.replace(/fill=".*?"/g, 'fill="none"')}
                        onError={(error) => console.log(error.message)}
                        />}
                      {!obj.icon && obj.typeName === "document" && <Icons.Documents className="iconLg" />}
                      {!obj.icon && obj.typeName === "mapbox" && <Icons.Map className="iconLg" />}
                      {!obj.icon && obj.typeName === "gallery" && <Icons.GalleryImages className="iconLg" />}
                      {!obj.icon && obj.typeName === "webgl" && <Icons.ThreeD className="iconLg" />}
                      {!obj.icon && obj.typeName==="stack" && <Icons.StackBuilding className="iconLg" />}
                      {!obj.icon && obj.typeName === "timeline" && <Icons.Timeline className="iconLg" />}
                      {obj.typeName === "mapbox" && "Maps"}
                
                      {(obj.typeName !== "mapbox") && obj.title}
          
                        
                    </NavLink>
            
                  ))}
                  {(modules && modules
                    .filter(a => a.typeName === "screensaver")
                    .map((obj, i) =>
                    <span 
                      key={"module_" + i}
                      onClick={(e) =>  onModuleContext(e, "screensaver", obj.id)}
                      className={"moduleIcon ui"}
                      onContextMenu={(e) => onModuleContext(e, "screensaver", obj.id)}
                    >
                      
                      
                      {obj.icon &&  <Icons.Screensaver className="iconLg" />}
                      
                      {obj.title}
          
                        
                    </span>
            
                  ))}
                  <span className={"moduleIcon"}  onClick={() => setShowModuleForm(true)}>
                    <Add className="iconLg ui addNew" />
                    Add
                  </span>
                  
                  
                  
                  </div>


                
                  

            </nav>
            <div className="rightNav settingsOn" id="manifestColumn">
            <div className="mediaSettings showSettings on">
          <div className="settingsGroup">
              <div className="row row2">
                  <div className="groupLabel"><p>Space Settings</p></div>
            
                  <div className="settingsRow">

                  <div className="fieldRow">
                      <div className="errors"></div>
              
                        <div className="canvasLabel">Space Title</div>
                        <input type="text" autoComplete="off" id="sectionSubTitle" defaultValue={narrative.subheading} onKeyUp={(e) => handleNewSubTitle(e, 'narrativeSubTitle')} />

                  </div>
                  </div>
            
                  <div className="settingsRow">
                    <div className="fieldRow">
                        <div className="errors"></div>
                
                          <div className="canvasLabel">Deck Title</div>
                          <input type="text" autoComplete="off" id="sectionTitle" defaultValue={narrative.title} onKeyUp={(e) => handleNewTitle(e, 'narrativeTitle')} />
                      
                    </div>

                    </div>
          
           
              </div>
              <div className="row row2">
              <div className="row settingsGridFull">
                <div className="canvasLabel" onClick={(e) => handleDropDown(e, 'group')}>Category</div>
                
                <span className={'flex alignCenter'}>
                  <div className="dropDownRow" id="settingsRow_group">
                    <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'group')}>{narrative.group ? narrative.group.name : <span className="canvasLabel">Select Category</span>} <ChevronDown className="icon" /></div>
                      <span className="inputField dropDownField" id={"inputField_group"}>
                        <span className="dropDown">
                          <span className="dropDownChoices">

                            {groups && groups.map((obj, i) => <span key={obj.id} className={"dropDownChoice ui"} onClick={() =>  handleNarrativeSave('group', obj.id)}>{obj.name}</span>)}
                      
                              <span className="addChoice"><span className={"dropDownChoice ui"} onClick={() => setShowCategoryForm(true)}>+ Add Category</span></span>
                          </span>
                        </span>
                      </span>
                  </div>
                  {narrative.group && <span className={'canvasLabel ui'} onClick={() => handleNarrativeSave('group', null)}>Clear</span>}
                </span>

                </div>
         
            </div>
              <div className="row row2">
                <div className="row settingsGridFull">
                  <div className="canvasLabel">Status</div>
                  <div className="dropDownRow" id="settingsRow_status">
                    <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'status')}>{narrative.status ? narrative.status : <span className="label">Update Status</span>} <ChevronDown className="icon" /></div>
                      <span className="inputField dropDownField" id={"inputField_status"}>
                        <span className="dropDown">
                          <span className="dropDownChoices">
                          
                              <span className={"dropDownChoice ui"} onClick={() => handleStatus('live')}>Live</span>
                              <span className={"dropDownChoice ui"} onClick={() => handleStatus('draft')}>Draft</span>
        
                          </span>
                        </span>
                      </span>
                  </div>
              </div>
            </div>
            <div className="row row2" style={{display: "none"}}>
              <div className="row settingsGridFull">
                  <div className="canvasLabel">Page Transition</div>
                  <div className="dropDownRow" id="settingsRow_transition">
                    <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'transition')}>{narrative.transition ? narrative.transition : <span className="label">Update Transition</span>} <ChevronDown className="icon" /></div>
                      <span className="inputField dropDownField" id={"inputField_transition"}>
                        <span className="dropDown">
                          <span className="dropDownChoices">
                          
                              <span className={"dropDownChoice ui"} onClick={() => handleTransition('fade')}>Fade</span>
                              <span className={"dropDownChoice ui"} onClick={() => handleTransition('scroll')}>Scroll</span>
        
                          </span>
                        </span>
                      </span>
                  </div>
              </div>
            </div>
            <div className="selectFileRow">
                <div className="canvasLabel ui" onClick={() => document.getElementById('screenshot').click()}>Thumbnail</div>
                <div className="iconField ui" onClick={() => document.getElementById('screenshot').click()}>{narrative.screenshot ? fileNameType(narrative.screenshot, null).map((obj2, j) => (
                  <span
                  
                  key={"fileName_" + j}>{obj2}</span>)) : <span className="canvasLabel">Add File</span>}</div>

                {narrative.screenshot && <img src={Config.mediaURL + narrative.screenshot} className="thumbnail ui" alt="" onClick={() => document.getElementById('screenshot').click()} />}
                <input type="file" style={{"display": "none"}} id="screenshot" accept={"image/png, image/jpeg, image/webp"} multiple={false} onChange={() => handleNarrativeMedia("screenshot")} />
            </div>
          </div>
            <div className="settingsGroup">

            <div className="groupLabel"><p>Theme</p></div>
            
            <div className="row settingsGrid">
                  {props.user.role && props.user.role !== 'superuser' ? 
                  <React.Fragment>
                  <div className="canvasLabel" onClick={() => animColorPicker(animOpen, 'colorPicker0')}>Background Color</div>
                  <div className="colorChip" 
                  style={{
                    background: (narrative.theme_css && narrative.theme_css['primary-background']) ? narrative.theme_css['primary-background'] : 'none'
                  }}></div>
                  </React.Fragment>
                  : 
                  <React.Fragment>
                    <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker0')}>Background Color</div>
                    <div className="ui colorChip" 
                    style={{
                      background: (narrative.css && narrative.css['primary-background']) ? narrative.css['primary-background'] : 'none'
                    }}
                    onClick={() => animColorPicker(animOpen, 'colorPicker0')}></div>
                
                    <span 
                    id="colorPicker0"
                    className="colorPicker"
                    >
                    <ChromePicker
                        color={tempColor?tempColor:((narrative.css && narrative.css['primary-background'])?narrative.css['primary-background']:"")}
                        disableAlpha={true}
                        onChange={(color) => {
                          setTempColor(color.hex)
                        }}
                        onChangeComplete={(color, event) => {
                          // console.log('color, event', color, event)
                          
                          if (tempColor) {
                            handleThemeCss('css', 'primary-background', tempColor)
                          }
                          if (!tempColor && color.hex) {
                            handleThemeCss('css', 'primary-background', color.hex) 
                          }
                        }}
                      />
                      
                      </span>
                  </React.Fragment>
                }
                
            </div>
            <div className="row settingsGrid">

              {props.user.role && props.user.role !== 'superuser' ? 
              <React.Fragment>
                <div className="canvasLabel" onClick={() => animColorPicker(animOpen, 'colorPicker1')}>Primary Color</div>
                <div className="colorChip" 
                style={{
                  background: (narrative.theme_css && narrative.theme_css['primary']) ? narrative.theme_css['primary'] : 'none'
                }}
                ></div>
              </React.Fragment>

              : <React.Fragment>
              <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker1')}>Primary Color</div>
              <div className="ui colorChip" 
              style={{
                background: (narrative.css && narrative.css['primary']) ? narrative.css['primary'] : 'none'
              }}
              onClick={() => animColorPicker(animOpen, 'colorPicker1')}></div>
             
              <span 
              id="colorPicker1"
              className="colorPicker"
              >
              <ChromePicker
                  color={tempColor?tempColor:((narrative.theme_css && narrative.theme_css['primary'])?narrative.theme_css['primary']:"")}
                  disableAlpha={true}
                  onChange={(color) => {
                    setTempColor(color.hex)
                  }}
                  onChangeComplete={(color, event) => {
                    

                    if (tempColor) {
                      handleThemeCss('css', 'primary', tempColor) 
                    }
                    if (!tempColor && color.hex) {
                      handleThemeCss('css', 'primary', color.hex) 
                    }
             
                  }}
                />
                </span>
              </React.Fragment>
              }
                
            </div>
            <div className="row settingsGrid">
            {props.user.role && props.user.role !== 'superuser' ? 
            <React.Fragment>
              <div className="canvasLabel" onClick={() => animColorPicker(animOpen, 'colorPicker2')}>Secondary Color</div>
              <div className="colorChip" 
                style={{
                  background: (narrative.theme_css && narrative.theme_css['secondary'] ) ? narrative.theme_css['secondary'] : 'none'
                }}
               ></div>
      
            </React.Fragment>

            : <React.Fragment>
              
                <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker2')}>Secondary Color</div>
                <div className="ui colorChip" 
                style={{
                  background: (narrative.theme_css && narrative.theme_css['secondary']) ? narrative.theme_css['secondary'] : 'none'
                }}
                onClick={() => animColorPicker(animOpen, 'colorPicker2')}></div>
                
                <span 
                id="colorPicker2"
                className="colorPicker"
                >
                <ChromePicker
                    color={tempColor?tempColor:((narrative.css && narrative.css['secondary'])?narrative.css['secondary']:"")}
                    disableAlpha={true}
                    onChange={(color) => {
                      setTempColor(color.hex)
                    }}
                    onChangeComplete={(color, event) => {
                      console.log('color', color.hex, tempColor)

                      if (tempColor) {
                        handleThemeCss('css', 'secondary', tempColor) 
                      }
                      if (!tempColor && color.hex) {
                        handleThemeCss('css', 'secondary', color.hex) 
                      }
                     
                    }}
                  />
                  </span>
                  </React.Fragment>

            }

            </div>
            
            <div className="row selectFileRow">
            <div className="canvasLabel ui" onClick={() => document.getElementById('menu_logo').click()}>Menu Logo</div>
            <div className="iconField ui" onClick={() => document.getElementById('menu_logo').click()}>{narrative.menu_logo ? fileNameType(narrative.menu_logo, null).map((obj2, j) => (
              <span
              
              key={"fileName_" + j}>{obj2}</span>)): <span className="canvasLabel">Add File</span>}</div>
    
            <input type="file" style={{"display": "none"}} id="menu_logo" accept={acceptValues} multiple={false} onChange={() => handleNarrativeMedia("menu_logo")} />
        </div>
        <div className="row selectFileRow">
            <div className="canvasLabel ui" onClick={() => document.getElementById('menu_background').click()}>Landing Page Background</div>
            <div className="iconField ui" onClick={() => document.getElementById('menu_background').click()}>{narrative.menu_background ? fileNameType(narrative.menu_background, null).map((obj2, j) => (
              <span
              
              key={"fileName_" + j}>{obj2}</span>)) : <span className="canvasLabel">Add File</span>}</div>
            <input type="file" style={{"display": "none"}} id="menu_background" accept={acceptValues} multiple={false} onChange={() => handleNarrativeMedia("menu_background")} />
        </div>
        

          </div>
        

          {narrative.insets && narrative.insets.length > 0 && <div className="settingsGroup">
            <div className="row selectFileRow">
              <div className="canvasLabel ui">Default Page Backgrounds</div>
              
            
              {narrative.insets.map((obj, k) => (
                <span key={'inset_' + k}>
                  <div className="canvasLabel">{obj.display_name}</div>
                  <div className="iconField ui" onClick={() => document.getElementById('narrative_bkg_' + obj.id).click()}>{obj.image ? fileNameType(obj.image, null).map((obj2, j) => (
                    <span key={"fileName_" + j}>{obj2}</span>)) : <span className="canvasLabel">Add File</span>}</div>
                  <input type="file" style={{"display": "none"}} id={'narrative_bkg_' + obj.id} accept={acceptValues} multiple={false} onChange={() => handleNarrativeBackground('narrative_bkg_' + obj.id, obj.id)} />
                  
                </span>
                
              ))}
             
            </div>
          </div>}

          </div> 

        
          
          
        </div>    
           
          

         </div>}
        
        
      </section>
    );
}

export default Narrative;
